// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { TooltipPresentationProps } from "@synd/MobiusOverrides/Tooltip/Tooltip";
import Info from "@synd/XDL/Icons/NotificationInfoCircle";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { xBaseTheme } from "@synd/XDL/types";
import { color, getSystemColor } from "@synd/XDL/Utilities";
import { css } from "styled-components";

export const breadcrumbsTooltipStyles = {
    tooltipContent: {
        css: css`
            .tooltipInfo {
                padding: 0;
            }
            ${IconWrapper} {
                display: none;
            }
        `,
    },
    tooltipArrow: {
        style: {
            fill: `${getSystemColor("common.ui7")}`,
        },
    },
};

export default {
    defaultProps: {
        mergeCss: true,
        extendedStyles: {
            tooltipContent: {
                css: css`
                    background-color: ${color("common.ui7")};
                    color: ${color("common.ui1")};
                    border-radius: 2px;
                    padding: 0;
                    font-size: ${fontConfig.xSmallSingleLine.size}px;
                    line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                    .tooltipInfo {
                        display: flex;
                        flex-direction: column;
                        flex: 0 0 auto;
                        padding: 8px;
                    }
                `,
            },
            tooltipArrow: {
                stroke: `${color("common.ui7")}`,
                fill: `${color("common.ui7")}`,
            },
            triggerWrapper: {
                css: css`
                    display: inline-block;
                    vertical-align: middle;
                    height: fit-content;
                    width: fit-content;
                    line-height: 12px;
                    margin-left: 6px;
                    &:hover {
                        &,
                        & ${IconWrapper} {
                            color: ${color("common.ui10")};
                        }
                    }
                `,
            },
        },
        iconProps: {
            mergeCss: true,
            src: Info,
            size: 12,
            ...{ height: 13 },
            color: "common.ui11",
            css: css`
                top: 0;
                color: ${color("common.ui11")};
                &:hover {
                    color: ${color("common.ui10")};
                    cursor: pointer;
                }
                & > svg {
                    height: 16px;
                }
            `,
        },
        typographyProps: {
            size: fontConfig.xSmallSingleLine.size,
            weight: fontConfig.weight.regular,
            color: "common.ui1",
            css: css`
                line-height: ${fontConfig.xSmallSingleLine.lineHeight};
                text-align: center;
                letter-spacing: 0;
                white-space: break-spaces;
                word-break: break-word;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    } as TooltipPresentationProps,
} as xBaseTheme["tooltip"];
